($ => {
  const host = window.location.host.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // Match host with optional basic auth credentials (user:pass@)
  const hostPattern = new RegExp(`https?://([^@]+@)?${host}`);
  $('a').each(function () {
    if (
      this.href.length > 0 &&
      !hostPattern.test(this.href) &&
      !this.href.startsWith('tel:') &&
      !this.href.startsWith('mailto:') &&
      !this.href.startsWith('#')
    ) {
      $(this).addClass('external-link');
    }
  });
})(jQuery);
